import { useState } from "react";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { PageHeader } from "../components/Shared";
import { Button } from "../components/ui/button";
import { Sparkle, Robot } from "@phosphor-icons/react";
import { toast } from "sonner";

function renderMarkdown(md) {
  const lines = md.split("\n");
  const out = [];
  lines.forEach((line, i) => {
    if (line.startsWith("## ")) {
      out.push(<h3 key={i} className="font-display text-lg font-semibold text-primary mt-6 mb-2">{line.slice(3)}</h3>);
    } else if (line.startsWith("# ")) {
      out.push(<h2 key={i} className="font-display text-xl font-semibold mt-6 mb-2">{line.slice(2)}</h2>);
    } else if (line.trim().startsWith("- ") || line.trim().startsWith("* ")) {
      out.push(<li key={i} className="text-muted-foreground ml-5 list-disc py-0.5">{line.trim().slice(2)}</li>);
    } else if (line.trim() === "") {
      out.push(<div key={i} className="h-2" />);
    } else {
      const parts = line.split(/(\*\*[^*]+\*\*)/g).map((p, j) =>
        p.startsWith("**") ? <strong key={j} className="text-foreground">{p.slice(2, -2)}</strong> : p);
      out.push(<p key={i} className="text-muted-foreground py-0.5">{parts}</p>);
    }
  });
  return out;
}

export default function Insights() {
  const [insights, setInsights] = useState("");
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    setLoading(true);
    try {
      const res = await api.post("/ai/insights");
      setInsights(res.data.insights);
    } catch (e) { toast.error("AI analizi başarısız. Veri eklediğinizden emin olun."); }
    finally { setLoading(false); }
  };

  return (
    <Layout>
      <PageHeader
        title="AI Finansal Analiz"
        subtitle="Yapay zeka destekli nakit akışı tahmini ve öneriler"
        action={
          <Button data-testid="generate-insights-button" onClick={generate} disabled={loading} className="gap-2">
            <Sparkle size={18} weight={loading ? "regular" : "fill"} className={loading ? "animate-spin" : ""} />
            {loading ? "Analiz ediliyor..." : "Analiz Oluştur"}
          </Button>
        }
      />

      {!insights && !loading && (
        <div className="flex flex-col items-center justify-center py-24 text-center border border-dashed border-border rounded-lg noise-bg" data-testid="insights-empty">
          <div className="w-16 h-16 rounded-full bg-primary/15 flex items-center justify-center mb-6">
            <Robot size={32} className="text-primary" />
          </div>
          <h3 className="font-display text-xl font-semibold mb-2">Finansal verilerinizi analiz edelim</h3>
          <p className="text-muted-foreground max-w-md">
            Yapay zeka, gelir-gider dengenizi, yaklaşan ödemelerinizi ve nakit akışınızı değerlendirerek size özel öneriler sunar.
          </p>
        </div>
      )}

      {loading && (
        <div className="flex flex-col items-center justify-center py-24" data-testid="insights-loading">
          <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-muted-foreground">Finansal verileriniz analiz ediliyor...</p>
        </div>
      )}

      {insights && !loading && (
        <div className="bg-card border border-border rounded-md p-8 max-w-3xl fade-up" data-testid="insights-result">
          <div className="flex items-center gap-2 mb-6 pb-4 border-b border-border">
            <Sparkle size={20} weight="fill" className="text-primary" />
            <span className="font-display font-semibold">AI Değerlendirmesi</span>
          </div>
          <div className="text-sm leading-relaxed">{renderMarkdown(insights)}</div>
        </div>
      )}
    </Layout>
  );
}
